<template>
  <f7-page>
    <navbar :text="$t('PhenologiesDatabase_title')" />
    <DxPhenologiesDatabase />
  </f7-page>
</template>

<script>

import DxPhenologiesDatabase from '../../components/scouting/DxPhenologiesDatabase.vue';
import navbar from '../../components/NavBar.vue';

export default {
  components: {
    DxPhenologiesDatabase,
    navbar,
  },
};
</script>

<style>

</style>
